import { Component, OnInit } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { getBrandLogoPath } from "../shared/branding/branding.util";
import { EesiApplication } from "./eesi.interface";

@Component({
  selector: "app-eesi",
  templateUrl: "./eesi.component.html",
  styleUrls: ["./eesi.component.scss"],
  standalone: false,
})
export class EesiComponent implements OnInit {
  readonly logoPath = getBrandLogoPath("white");
  submitted = false;
  isSubmitting = false;

  application: EesiApplication = {
    company: "",
    email: "",
    systems: "",
  };

  currentYear: number = new Date().getFullYear();

  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    this.initializeIframeCommunication();
  }

  scrollToForm(): void {
    const element = document.getElementById("partner-form");
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }

  onSubmit(): void {
    if (
      this.isSubmitting ||
      !this.application.company ||
      !this.application.email ||
      !this.application.systems
    ) {
      return;
    }

    this.isSubmitting = true;

    this.http.post("/api/eesi-application", this.application).subscribe({
      next: () => {
        this.submitted = true;
        this.isSubmitting = false;
        this.application = {
          company: "",
          email: "",
          systems: "",
        };

        setTimeout(() => {
          this.submitted = false;
        }, 5000);
      },
      error: () => {
        this.isSubmitting = false;
        alert("An error occurred. Please try again.");
      },
    });
  }

  private initializeIframeCommunication(): void {
    this.sendHeightToParent();

    window.addEventListener("resize", () => this.sendHeightToParent());

    const observer = new MutationObserver(() => {
      this.sendHeightToParent();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
    });
  }

  private sendHeightToParent(): void {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const height = document.body.scrollHeight;

        if (window.parent && window.parent !== window) {
          window.parent.postMessage(
            {
              type: "RESIZE_IFRAME",
              height,
            },
            "*",
          );
        }

        window.postMessage(
          {
            type: "RESIZE_IFRAME",
            height,
          },
          "*",
        );
      });
    });
  }
}
